export default {
    setIsLogin: (state, v) => state.isLogin = v,
    setConfigData: (state, v) => state.configData = v,
    setBaseQuotes: (state, v) => state.baseQuotes = v,
    setUpdateQuotes: (state, v) => state.updateQuotes = v,
    setInnerHeight: (state, v) => state.innerHeight = v,
    setSymbolList: (state, v) => state.symbolList = v,
    setIsShowBalance: (state, v) => state.showBalance = v,
    setInvestData: (state, v) => state.investData = v,
    setUserInfo: (state, v) => state.userInfo = v,
    setLanguage: (state, v) => state.language = v,
    setRateList: (state, v) => state.rateList = v,
    setCurrentRate: (state, v) => state.currentRate = v,
    setAuthInfo: (state, v) => state.authInfo = v,
    setThemeType: (state, v) => state.themeType = v,
    setLanguages: (state, v) => state.languages = v,
    setIsApp: (state, v) => state.isApp = v,
    setLastPrice: (state, v) => state.lastPrice = v
}